<template>
  <div class="flex justify-between items-center h-fit mb-8">
    <div class="flex w-full items-center">
      <!-- Bouton retour -->
      <button class="h-fit !m-0 !px-2 !bg-transparent flex items-center justify-center text-gray-400 !font-normal cursor-pointer" @click="$router.go(-1)">
        <i class="fa-solid fa-arrow-left "></i>
        <div class="!text-2xl">&nbsp;Projets/</div>
      </button>
      <!-- Titre -->
      <input
        class="basicInput w-1/2 text-xl text-left flex items-center truncate"
        type="text"
        v-model="project.name"
        placeholder="Nom du projet"
        :disabled="perm().projects != 'modification'"
      >
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  name: 'ProjectHeader',
  props: ['project'],
  setup(){
    const perm = inject('userPerm');
    return { perm };
  }
}
</script>